import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledAlert
} from 'reactstrap';
// import Select from 'react-select';
import Select from 'react-select/async';
import BootstrapTable from 'react-bootstrap-table-next';
import RFForm from '../../../components/Form/RFForm';
import DataEmptyState from '../../../commons/dataemptystate';
import QueryEmptyState from '../../../commons/queryempty';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from './services';
import { DatePicker, PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import Lib from '../../../commons/lib';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import NumberFormatter from '../../../commons/NumberFormatter';
import TimeFormatter from '../../../commons/TimeFormatter';

class GDPRLista extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // ['QUERY', 'LOAD', 'DATA', 'NETW', 'TABL']
      currentStatusBaseTable: 'QUERY',
      modalBaseView: false,
      eloszuresPartner: '',
      datum: TimeFormatter.formatDate(moment()),
      elevulesCheckText: '',
      elofordulasCheckTexT: '',
      elofordulasEmpty: false,
      elofordulasIds: [],
      baseJson: [],
      selectedRows: [],
      // [0,1,2,3]
      deleteStatus: 0,
      disabledRows: [],
      modalDelete: false,
      lekerdezesButtonLoading: false,
      deleteButtonLoading: false,
    };
  }

  componentDidMount() {
    // this.updateBaseTable();
  }

  onRowSelect = (row) => {
    this.updateChildTable(row.id);
  }

  formDatumChange = (e, v) => {
    let currentValue = v === '' ? null : v;
    this.setState({ datum: currentValue });
  }

  toggleBaseView = () => {
    this.setState({
      modalBaseView: !this.state.modalBaseView
    });
  }

  toggleDelete = () => {
    this.setState({
      modalDelete: !this.state.modalDelete,
      deleteStatus: 0,
      elofordulasEmpty: false,
    });
  }

  toggleDeleteAndReload = () => {
    this.setState({
      modalDelete: !this.state.modalDelete,
      deleteStatus: 0,
      elofordulasEmpty: false,
      selectedRows: []
    }, () => {
      this.updateBaseTable();
    });
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  updateBaseTable = () => {
    let partnerId = this.emptyOrNull(this.state.eloszuresPartner.id);
    this.setState({
      currentStatusBaseTable: 'LOAD',
      lekerdezesButtonLoading: true,
    });
    Services.getGDPRList(partnerId, this.state.datum, (err, res) => {
      if (err) {
        this.setState({
          currentStatusBaseTable: 'QUERY',
          lekerdezesButtonLoading: false,
        });
      } else {
        let data = [];
        let rows = res[0];
        let disabledRows = [];
        let now = TimeFormatter.formatDate(moment());
        rows.forEach((item, idx) => {
          if (item.e === null || item.l > now) {
            disabledRows.push(item.id);
          }
          item.idx = idx;
          data.push(item);
        });
        this.setState({
          baseJson: data,
          disabledRows: disabledRows,
          currentStatusBaseTable: res[0].length > 0 ? 'TABL' : 'DATA',
          selectedRows: [],
          lekerdezesButtonLoading: false,
        }, () => { this.forceUpdate(); });
      }
    });
  }

  handleChangePartner = (value) => {
    if (value && value.length !== 0) {
      this.setState({ eloszuresPartner: value });
    } else {
      this.setState({ eloszuresPartner: '' });
    }
  }

  loadPartnerChange = (input, callback) => {
    if (input.length !== 0) {
      Services.getPartner(input, (err, res) => {
        if (!err) {
          let newArray = [];
          res[0].forEach((item) => {
            let newItem = item;
            newItem.nev += (newItem.cim ? ' (' + newItem.cim + ') ' : '');
            if (newItem.adoszam) {
              newItem.nev += '[' + NumberFormatter.addHyphensToString(newItem.adoszam) + '] ';
            }
            newArray.push(newItem);
          });
          callback(newArray);
        }
      });
    }
  }

  renderEloSzures = () => {
    return (
      <RFForm style={{ marginBottom: 20 }}>
        <div className="row">
          <div className="col-md-4">
            <Label for="jogtulaj">
              {'Partner:'}
            </Label>
            <Select
              styles={{
                control: base => ({
                  ...base,
                  '&:focus': { borderColor: 'red' }, // border style on hover
                  border: '1px solid lightgray', // default border color
                  boxShadow: 'none', // no box-shadow
                  borderRadius: '0'
                }),
              }}
              name="jogtulaj"
              id="jogtulaj"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              searchPromptText="Kezdj el gépelni a kereséshez..."
              loadingMessage={() => 'Keresés...'}
              onChange={v => this.handleChangePartner(v)}
              isClearable
              ignoreAccents={false}
              loadOptions={_.debounce(this.loadPartnerChange, 1000)}
              isLoading={false}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={this.state.eloszuresPartner}
              cache={false}
              autoload={false}
            />
          </div>
          <div className="col-md-3">
            <DatePicker
              label="Elévülés dátuma:"
              required
              placeholder="éééé-hh-nn"
              onChange={this.formDatumChange}
              value={this.state.datum && new Date(this.state.datum)}
              name="datum"
            />
          </div>
          <div className="col-md-4" style={{ marginTop: '29px' }}>
            <ProgressButton
              color="primary"
              onClick={() => { this.updateBaseTable(); }}
              loading={this.state.lekerdezesButtonLoading}
            >
              {'Lekérdezés'}
            </ProgressButton>
          </div>
        </div>
      </RFForm>
    );
  }

  delete = () => {
    if (this.state.selectedRows.length > 0) {
      let selectedRows = [...this.state.selectedRows];
      selectedRows.forEach(row => row.f = row.d);
      this.setState({
        deleteButtonLoading: true
      });
      Services.checkElevules(selectedRows, (err, res) => {
        if (!err) {
          this.toggleDelete();
          this.setState({
            elevulesCheckText: res[0].result,
          });
        }
        this.setState({
          deleteButtonLoading: false
        });
      });
    }
  }

  onSelectAll = (isSelected, rows) => {
    if (isSelected) {
      this.setState({ selectedRows: rows });
      return rows.map(row => row.id);
    }
    this.setState({ selectedRows: [] });
    return [];
  }

  onSelect = (row, isSelected) => {
    let selectedRows = [...this.state.selectedRows];
    if (isSelected) {
      selectedRows.push(row);
    } else {
      selectedRows = selectedRows.filter(oldRow => oldRow.id != row.id);
    }
    this.setState({ selectedRows });
  }

  rowClassNameFormat = (row) => {
    return row.l <= TimeFormatter.formatDate(moment()) ? 'td-column-gdpr-outdated' : '';
  }

  renderBaseTable = () => {
    const selectRowProp = {
      nonSelectable: this.state.disabledRows,
      onSelectAll: this.onSelectAll,
      onSelect: this.onSelect,
      mode: 'checkbox',
      hideSelectColumn: this.state.disabledRows.length === this.state.baseJson.length
    };

    const options = {
      sizePerPage: 10,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const columns = [
      {
        dataField: 'f',
        text: 'Funkció',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal' },
      },
      {
        dataField: 'a',
        text: 'Azonosító',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal' },
      },
      {
        dataField: 'p',
        text: 'Partner neve',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal' },
        align: 'center',
      },
      {
        dataField: 'd',
        text: 'Funkció dátum',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal', width: 140 },
        align: 'center',
      },
      {
        dataField: 'e',
        text: 'Elévülési idő (Év)',
        style: { whiteSpace: 'pre-line', width: 130 },
        align: 'center',
      },
      {
        dataField: 'l',
        text: 'Elévülés dátuma',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal', width: 140 },
        align: 'center'
      },
      {
        dataField: 'id',
        text: 'Azonosító',
        style: { whiteSpace: 'normal', width: 100 },
        hidden: true
      },
    ];

    return (
      <div className="animated fadeIn">
        <h5>
          {'GDPR lista'}
        </h5>
        <BootstrapTable
          bootstrap4
          keyField="id"
          columns={columns}
          ref={((c) => { this.lista = c; })}
          data={this.state.baseJson}
          selectRow={selectRowProp}
          rowClasses={this.rowClassNameFormat}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
        />
      </div>
    );
  }

  getProgressClassName = (currentPos) => {
    let className = '';
    if (currentPos === this.state.deleteStatus) {
      if (currentPos === 1 || currentPos === 3) {
        className = 'nav-item active';
      } else {
        className = 'nav-item current';
      }
    } else if (currentPos < this.state.deleteStatus) {
      className = 'nav-item active';
    } else {
      className = 'nav-item';
    }
    return className;
  }

  renderProgressState = () => {
    return (
      <div>
        {{
          0: (<UncontrolledAlert color="warning" className="animated fadeIn" toggle={null} style={{ marginTop: 20, whiteSpace: 'pre-wrap' }}>
            {this.state.elevulesCheckText}
          </UncontrolledAlert>),
          1: (<UncontrolledAlert color="success" className="animated fadeIn" toggle={null} style={{ marginTop: 20, whiteSpace: 'pre-wrap' }}>
            Napló törölve! Tovább lép?
          </UncontrolledAlert>),
          2: (<UncontrolledAlert color="info" className="animated fadeIn" toggle={null} style={{ marginTop: 20, whiteSpace: 'pre-wrap' }}>
            {this.state.elofordulasCheckTexT}
          </UncontrolledAlert>),
          3: (<UncontrolledAlert color="success" className="animated fadeIn" toggle={null} style={{ marginTop: 20, whiteSpace: 'pre-wrap' }}>
            Partner törölve!
          </UncontrolledAlert>),
        }[this.state.deleteStatus]}
      </div>
    );
  }

  nextProgress = () => {
    let state = this.state.deleteStatus;
    if (state < 3) {
      if (state === 0) {
        let array = [...this.state.selectedRows];
        let ids = [];
        array.forEach((item) => {
          ids.push([item.id, item.idp]);
        });
        Services.deleteBySelect(ids, (err, res) => {
          if (!err) {
            state = 2;
            this.setState({
              deleteStatus: 2,
              elofordulasCheckTexT: res[0].result,
            });
          }
        });
      } else if (state === 2) {
        state += 1;
        this.setState({
          deleteStatus: state,
        });
      }
      // state += 1;
    }
    // console.log(state);
    // this.setState({
    //   deleteStatus: state
    // });
  }

  render() {
    return (
      <div>
        {this.renderEloSzures()}
        {{
          QUERY: (<QueryEmptyState
            hasImage
          />),
          LOAD: (<Loader />),
          DATA: (<DataEmptyState
            hasImage
            subtitle="Próbálj más előszűrést vagy vigyél fel új adatokat!"
          />),
          NETW: (<NetworkEmptyState
            hasImage
            submitClick={() => this.updateBaseTable()}
          />),
          TABL: (this.renderBaseTable())
        }[this.state.currentStatusBaseTable]}
        { this.props.globals.hasRole(['GDPR_NAPLO'], true) && (
          <div>
            <ProgressButton
              type="button"
              className="pull-left"
              color="danger"
              onClick={this.delete}
              loading={this.state.deleteButtonLoading}
              disabled={this.state.selectedRows.length == 0}
            >
              {'Törlés'}
            </ProgressButton>
          </div>
        )}
        <Modal
          isOpen={this.state.modalDelete}
          toggle={this.toggleDelete}
          className={this.props.className}
          backdrop="static"
          size="GDPR"
        >
          <ModalHeader>
            Törlés folyamat
          </ModalHeader>
          <ModalBody>
            <div id="smartwizard" className="sw-main sw-theme-arrows">
              <ul className="nav nav-tabs step-anchor">
                <li className={this.getProgressClassName(0)}>
                  <a>
                    Elévülés
                    <br />
                    <small>
                      Vizsgálat
                    </small>
                  </a>
                </li>
                <li className={this.getProgressClassName(1)}>
                  <a>
                    Napló
                    <br />
                    <small>
                      Törlés/Anonimizálás
                    </small>
                  </a>
                </li>
                <li className={this.getProgressClassName(2)}>
                  <a>
                    Előfordulás
                    <br />
                    <small>
                      Vizsgálat
                    </small>
                  </a>
                </li>
                {/* <li className={this.getProgressClassName(3)}>
                  <a>
                    Partner
                    <br />
                    <small>
                      Törlés
                    </small>
                  </a>
                </li> */}
              </ul>
              <div />
            </div>
            <div>
              {this.renderProgressState()}
            </div>
          </ModalBody>
          <ModalFooter>
            { ((this.state.deleteStatus < 2) && (!this.state.elofordulasEmpty)) ? (
              <Button
                className="btn-cursor-pointer"
                type="button"
                color="primary"
                onClick={this.nextProgress}
              >
                Igen
              </Button>
            ) : (
              <Button
                className="btn-cursor-pointer"
                type="button"
                color="secondary"
                onClick={this.toggleDeleteAndReload}
              >
                Bezárás
              </Button>
            )}
            { ((this.state.deleteStatus < 2) && (!this.state.elofordulasEmpty)) ? (
              <Button
                className="btn-cursor-pointer"
                type="button"
                color="secondary"
                onClick={this.toggleDeleteAndReload}
              >
                  Nem
              </Button>
            ) : <span />}
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

GDPRLista.propTypes = {
  className: PropTypes.string
};

export default GDPRLista;
